import { useEffect, RefObject, useCallback, useRef } from 'react';

interface UseHandleSyncScrollProps {
  firstRef: RefObject<HTMLDivElement>;
  secondRef: RefObject<HTMLDivElement>;
  handleScroll: (onSecondScroll?: boolean) => void;
}

const useHandleSyncScroll = (
  syncBothScrolls = false,
): UseHandleSyncScrollProps => {
  const firstRef = useRef<HTMLDivElement>(null);
  const secondRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(
    (onSecondScroll = false) => {
      const first = firstRef.current;
      const second = secondRef.current;

      if (first && second) {
        if (onSecondScroll) {
          first.scrollLeft = second.scrollLeft;
        } else {
          second.scrollLeft = first.scrollLeft;
        }
      }
    },
    [firstRef, secondRef],
  );

  useEffect(() => {
    const first = firstRef.current;
    const second = secondRef.current;

    if (first && second) {
      first.addEventListener('scroll', () => {
        handleScroll();
      });
      second.addEventListener('scroll', () => {
        handleScroll(true);
      });
    }

    return () => {
      if (first && second) {
        first.removeEventListener('scroll', () => {
          handleScroll();
        });
        second.removeEventListener('scroll', () => {
          handleScroll(syncBothScrolls);
        });
      }
    };
  }, [firstRef, secondRef, handleScroll, syncBothScrolls]);

  return { firstRef, secondRef, handleScroll };
};

export default useHandleSyncScroll;
